export default __webpack_public_path__ + "501e0b309dfe72ad7ea2d7fad1334ef9.png";